import type { FC } from "react";
import { useMemo } from "react";
import { motion } from "framer-motion";
import { Menu } from "antd";
import { useTranslations } from "next-intl";
import type { HeaderMenuItem } from "./HeaderDropdownMenu";
import { buildMobileMenuItems } from "./MenuConfig";
import { useAuth } from "@/context/AuthContext";

interface MobileMenuProps {
  isOpen: boolean;
  menuStructure: HeaderMenuItem[];
  currentPath: string;
  handleMenuClick: (path: string) => void;
  setIsDonateModalOpen: (open: boolean) => void;
}

const MobileMenu: FC<MobileMenuProps> = ({
  isOpen,
  menuStructure,
  currentPath,
  handleMenuClick,
  setIsDonateModalOpen,
}) => {
  const t = useTranslations("home.header");
  const { authState, logout, openLoginModal } = useAuth();

  // Build mobile menu items
  const mobileMenuItems = useMemo(
    () => buildMobileMenuItems(menuStructure, handleMenuClick, t, authState, logout, openLoginModal),
    [menuStructure, t, authState, handleMenuClick, setIsDonateModalOpen, logout, openLoginModal],
  );

  return (
    <motion.div
      initial={{ height: 0 }}
      animate={{ height: isOpen ? "auto" : 0 }}
      className="overflow-hidden lg:hidden bg-white shadow-md overflow-y-auto max-h-[calc(100vh-60px)]"
    >
      <Menu selectedKeys={[currentPath]} mode="vertical" className="border-none" items={mobileMenuItems} />
    </motion.div>
  );
};

export default MobileMenu;
